export default __webpack_public_path__ + "static/media/selectedcalendar.ebf46f19.svg";